import { ContentSection, PageWrap } from '@vwfs-bronson/bronson-react';
import { ConfirmInformation } from 'components/kyc/confirm-information/ConfirmInformation';
import React, { useEffect } from 'react';

export const ConfirmInformationPage: React.FC = () => {
    useEffect(() => {
        document.title = 'Mon compte';
    }, []);

    return (
        <ContentSection>
            <PageWrap size={'medium'}>
                <ConfirmInformation />
            </PageWrap>
        </ContentSection>
    );
};
